import ServiceExec from '@/common/utils/ServiceExec';
import { item } from '@/common/service/apiList';
import store from '@/store';
import { REMOVE_EMPTY_PARAMS } from '@/common/utils/module/FormattingSupport';
import { cloneDeep } from 'lodash';
import { isEmpty } from '@/common/utils/Util';
import { showTextModal } from '@/common/utils/ModalState';
import router from '@/router';

export default {
  async getProductListByCategory({ commit, getters, state }, payload) {
    const user = store.getters['user/getUserData'];
    const { data, status } = await ServiceExec.get(item.getProductListByCategory(user.userNo, payload.category));
    if (ServiceExec.status.OK !== status) return;

    // console.log('getProductListByCategory', data);
    commit('setShopItemList', data);
  },
  async getBuyMemorialList({ commit }) {
    const { userNo } = store.getters['user/getUserData'];
    const { data, status } = await ServiceExec.get(item.getBuyMemorialList + userNo);
    if (ServiceExec.status.OK !== status) return;

    commit('setBuyMemorialList', data || '');
    return data;
  },

  async getSmileBackgroundList({ commit }, { userNo, category }) {
    const userData = store.getters['user/getUserData'];
    const { data, status } = await ServiceExec.get(item.smileBackgroundImageList(userData.userNo, category));
    if (ServiceExec.status.OK !== status) return;
    commit('setList', data || '');
  },

  async getCategoryShopList({ commit }, { userNo, category }) {
    const { data, status } = await ServiceExec.get(item.getCategoryShopList(userNo, category));
    if (ServiceExec.status.OK !== status) return;

    commit('setCategoryShopList', data || '');
  },

  async getUserItemList({ commit, getters, state }, category) {
    const condition = cloneDeep(getters['getUserItemCondition']);

    if (condition.page > state.userPageInfo.totalPage) return;

    const { userNo } = store.getters['user/getUserData'];
    condition.userNo = userNo;
    condition.category = category;
    const { data, status } = await ServiceExec.get(item.getUserItem, REMOVE_EMPTY_PARAMS(condition));
    if (ServiceExec.status.OK !== status) return;

    condition.page = condition.page + 1;
    commit('setUserItemCondition', condition);
    commit('setUserPageInfo', data.pageInfo);
    commit('setUserItemList', { list: data.list, category: category });
  },

  // 사용자 이미지 직접등록 상품 정보 가져오기
  async getUserBgiProduct({ commit }) {
    try {
      const response = await ServiceExec.get('/api/shop/user/bgi');
      if (response?.status !== ServiceExec.status.OK) {
        return false;
      }

      return response?.data || {};
    } catch (error) {
      console.error('Error fetching user BGI product:', error);
      showTextModal('배경 이미지 정보를 불러오는데 실패했습니다.', '확인', () => {
        router.go(-1);
      });
      return null;
    }
  }
};

/**
 * Inside, Outside 필터링
 * @returns {*|*[]}
 * @param list
 * @param memorialType
 */
const inoutFilter = (list, memorialType) => {
  if (isEmpty(list)) return [];
  return list.map(item => ({
    ...item,
    canUse: memorialType === 'Inside' ? !item.productCode.includes('OUT') : !item.productCode.includes('IN')
  }));
};
